import React, { useState, useEffect } from "react";
import { Select, Radio, Input, Button, Tag, Tabs, List, Form } from "antd";
const { TabPane } = Tabs;
const timeOptions = [
  "Not setting a time",
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
];

const responsibleOptions = [
  { label: "PickUp", value: "pick_up" },
  { label: "DropOff", value: "drop_off" },
];
const weekDayGroups = {
  1: {
    parent1: [
      { label: "Monday, Tuesday", value: "Monday Tuesday" },
      { label: "Friday, Saturday, Sunday", value: "Friday Saturday Sunday" },
    ],
    parent2: [{ label: "Wednesday, Thursday", value: "Wednesday Thursday" }],
  },
  2: {
    parent2: [
      { label: "Monday, Tuesday", value: "Monday Tuesday" },
      { label: "Friday, Saturday, Sunday", value: "Friday Saturday Sunday" },
    ],
    parent1: [{ label: "Wednesday, Thursday", value: "Wednesday Thursday" }],
  },
};

const defaultTimes = {
  pick_up: "08:00",
  drop_off: "16:00",
};

const TwoTwoThreeCreate = (props) => {
  const {
    parentId,
    activeComboId,
    activeChildId,
    parentCombinationsV2,
    parentCombinations,
    index,
    modified,
    sameScheduleForAll,
  } = props;
  const parentCombo = parentCombinationsV2.find(
    (combo) =>
      String(combo?.coparent_combination_id || combo?.id) ===
      String(activeComboId)
  );

  // console.log(parentCombo, "parentCombo");

  let targetChild;
  if (!sameScheduleForAll) {
    targetChild = parentCombo?.children?.find(
      (child) => String(child.child_id || child?.id) === String(activeChildId)
    );
  } else {
    targetChild = parentCombo?.children[0];
  }
  const parent1 = parentCombo?.parent1;
  const parent2 = parentCombo?.parent2;
  const weekSchedules = props.weekSchedules;
  const setWeekSchedules = props.setWeekSchedules;
  const [form] = Form.useForm();

  const [selectedWeek, setSelectedWeek] = useState(index === 0 ? 1 : 2);

  const [showCustom, setShowCustom] = useState(false);
  const [customHour, setCustomHour] = useState();
  const [customMinute, setCustomMinute] = useState();
  const [selectedTime, setSelectedTime] = useState();

  const [parent1Days, setParent1Days] = useState([]);
  const [parent2Days, setParent2Days] = useState([]);
  const [weekSchedulesState, setWeekSchedulesState] = useState([]);
  const [parent1TabState, setParent1TabState] = useState({});
  const [parent2TabState, setParent2TabState] = useState({});

  function getInitialTabValueFromV2(dayKey, parentKey) {
    const combo = parentCombinationsV2?.find(
      (c) =>
        String(c?.coparent_combination_id || c.id) === String(activeComboId)
    );
    if (!combo) return { responsible: undefined, time: undefined };
    const child = targetChild;
    if (
      !child ||
      !Array.isArray(child.week_schedules) ||
      !child.week_schedules[0]
    )
      return { responsible: undefined, time: undefined };

    // Find the correct week object
    const weekObj = child.week_schedules[0];
    const weekKey = selectedWeek === 1 ? "week_number1" : "week_number2";
    const weekData = weekObj[weekKey];
    if (!weekData || !Array.isArray(weekData.segments))
      return { responsible: undefined, time: undefined };

    const seg = weekData.segments.find(
      (seg) =>
        Array.isArray(seg.selected_days) &&
        seg.selected_days.join(" ") === dayKey
    );
    if (!seg) return { responsible: undefined, time: undefined };

    let time = "";
    if (seg.responsible_for === "pick_up") {
      time = seg.pickup_time === null ? "Not setting a time" : seg.pickup_time;
    } else if (seg.responsible_for === "drop_off") {
      time =
        seg.dropoff_time === null ? "Not setting a time" : seg.dropoff_time;
    }
    return {
      responsible: seg.responsible_for,
      time,
    };
  }

  useEffect(() => {
    setWeekSchedulesState(weekSchedules);
  }, [weekSchedules]);

  const handleResponsibleForChange = (val) => {
    form.setFieldsValue({
      time: defaultTimes[val],
    });
  };

  useEffect(() => {
    if (typeof props.setParentCombinationsV2 === "function") {
      if (!parentCombo || !targetChild) return;

      if (modified) {
        props.setParentCombinationsV2((prev) =>
          prev.map((combo) => {
            if (
              String(combo?.id || combo?.coparent_combination_id) !==
              String(parentCombo?.id || parentCombo?.coparent_combination_id)
            ) {
              return combo;
            }
            return {
              ...combo,
              children: combo.children.map((child) => {
                if (
                  String(child?.id || child?.child_id) !==
                  String(targetChild?.id || targetChild?.child_id)
                ) {
                  return child;
                }
                if (child.schedule_type_id !== "41") return child;

                const updatedWeek = (weekSchedules || []).find(
                  (w) => w.week_number === selectedWeek
                );
                if (!updatedWeek) return child;

                const exitingWeekSe = child.week_schedules || [];
                const weekKey =
                  selectedWeek === 1 ? "week_number1" : "week_number2";

                const newWeekSchedules = exitingWeekSe.map((weekObj) => {
                  if (!weekObj[weekKey]) return weekObj;

                  // Update existing segments
                  const updatedSegments = (weekObj[weekKey].segments || []).map(
                    (seg) => {
                      const match = (updatedWeek.segments || []).find(
                        (us) =>
                          Array.isArray(us.selected_days) &&
                          Array.isArray(seg.selected_days) &&
                          us.selected_days.join(",") ===
                            seg.selected_days.join(",")
                      );
                      if (match) {
                        return {
                          ...seg,
                          responsible_for: match.responsible_for,
                          pickup_time: match.pickup_time,
                          dropoff_time: match.dropoff_time,
                        };
                      }
                      return seg;
                    }
                  );

                  // Add new segments
                  const existingKeys = (weekObj[weekKey].segments || []).map(
                    (seg) => `${seg.assigned_to}-${seg.selected_days.join(",")}`
                  );
                  const newSegments = (updatedWeek.segments || []).filter(
                    (us) =>
                      !existingKeys.includes(
                        `${us.assigned_to}-${us.selected_days.join(",")}`
                      )
                  );

                  return {
                    ...weekObj,
                    [weekKey]: {
                      ...weekObj[weekKey],
                      segments: [...updatedSegments, ...newSegments],
                    },
                  };
                });

                return {
                  ...child,
                  modified: modified || undefined,
                  week_schedules: newWeekSchedules,
                };
              }),
            };
          })
        );
      } else {
        props.setParentCombinationsV2((prev) =>
          prev.map((combo) => {
            if (
              String(combo?.id || combo?.coparent_combination_id) !==
              String(parentCombo?.id || parentCombo?.coparent_combination_id)
            ) {
              return combo;
            }
            return {
              ...combo,
              children: combo.children.map((child) => {
                if (
                  String(child?.id || child?.child_id) !==
                  String(targetChild?.id || targetChild?.child_id)
                ) {
                  return child;
                }

                const updatedWeekSchedules = (child.week_schedules || []).map(
                  (weekObj) => {
                    const weekKey =
                      selectedWeek === 1 ? "week_number1" : "week_number2";
                    if (!weekObj[weekKey]) return weekObj;

                    const updatedWeek = (weekSchedules || []).find(
                      (w) => w.week_number === selectedWeek
                    );
                    if (!updatedWeek) return weekObj;

                    return {
                      ...weekObj,
                      [weekKey]: {
                        ...weekObj[weekKey],
                        ...updatedWeek,
                        segments: updatedWeek.segments,
                      },
                    };
                  }
                );

                return {
                  ...child,
                  week_schedules: updatedWeekSchedules,
                };
              }),
            };
          })
        );
      }
    }
    // eslint-disable-next-line
  }, [weekSchedules]);

  useEffect(() => {
    if (!parentCombo || !targetChild) return;
    if (
      !Array.isArray(targetChild.week_schedules) ||
      !targetChild.week_schedules[0]
    )
      return;

    // Find the correct week object
    const weekObj = targetChild.week_schedules[0];
    const weekKey1 = "week_number1";
    const weekKey2 = "week_number2";
    const segments1 = weekObj[weekKey1]?.segments || [];
    const segments2 = weekObj[weekKey2]?.segments || [];

    // Helper to build state from segments
    const buildTabState = (segments, parentKey) => {
      const state = {};
      segments.forEach((seg) => {
        if (seg.assigned_to === parentKey) {
          const dayKey = Array.isArray(seg.selected_days)
            ? seg.selected_days.join(" ")
            : "";
          let time = "";
          if (seg.responsible_for === "pick_up") {
            time = seg.pickup_time;
          } else if (seg.responsible_for === "drop_off") {
            time = seg.dropoff_time;
          }
          state[dayKey] = {
            responsible: seg.responsible_for,
            time: time,
          };
        }
      });
      return state;
    };

    // Collect all day groups for each parent
    const getAllDayGroups = (segments, parentKey) =>
      segments
        .filter(
          (seg) =>
            seg.assigned_to === parentKey && Array.isArray(seg.selected_days)
        )
        .map((seg) => seg.selected_days.join(" "));

    // Set state for week 1 or 2 depending on selectedWeek
    if (selectedWeek === 1) {
      setParent1TabState(buildTabState(segments1, "parent1"));
      setParent2TabState(buildTabState(segments1, "parent2"));
      setParent1Days(getAllDayGroups(segments1, "parent1"));
      setParent2Days(getAllDayGroups(segments1, "parent2"));
    } else {
      setParent1TabState(buildTabState(segments2, "parent1"));
      setParent2TabState(buildTabState(segments2, "parent2"));
      setParent1Days(getAllDayGroups(segments2, "parent1"));
      setParent2Days(getAllDayGroups(segments2, "parent2"));
    }
  }, [parentCombo, targetChild, selectedWeek]);

  // Handle add segment
  const handleAddSegment = (values) => {
    setWeekSchedules((prev) => {
      // Find the week object (with week_number1/week_number2)
      let found = false;
      const weekKey = selectedWeek === 1 ? "week_number1" : "week_number2";
      const newSegment = {
        selected_days: values.segment.split(" "),
        assigned_to:
          values.responsibleFor === "pick_up" ? "parent1" : "parent2",
        responsible_for: values.responsibleFor,
        ...(values.responsibleFor === "pick_up"
          ? {
              pickup_time:
                values.time === "Not setting a time" ? null : values.time,
            }
          : {
              dropoff_time:
                values.time === "Not setting a time" ? null : values.time,
            }),
      };
      const updated = prev.map((weekObj) => {
        if (weekObj[weekKey]) {
          found = true;
          return {
            ...weekObj,
            [weekKey]: {
              ...weekObj[weekKey],
              segments: [...(weekObj[weekKey].segments || []), newSegment],
            },
          };
        }
        return weekObj;
      });
      if (!found) {
        // Add new week object if not found
        return [
          ...prev,
          {
            [weekKey]: {
              week_number: selectedWeek,
              [`parent${selectedWeek}_id`]:
                selectedWeek === 1 ? parent1?.user_id : parent2?.user_id,
              segments: [newSegment],
            },
          },
        ];
      }
      return updated;
    });
    form.resetFields();
    form.setFieldsValue({
      week: selectedWeek,
    });
    setSelectedTime(null);
  };

  const saveSegments = ({ parent, days, responsible, time }) => {
    const safeDays = Array.isArray(days) ? days : days ? [days] : [];
    setWeekSchedules((prev) => {
      const weekKey = selectedWeek === 1 ? "week_number1" : "week_number2";
      let found = false;
      const updated = prev.map((weekObj) => {
        if (weekObj[weekKey]) {
          found = true;
          // Remove any existing segment for this parent and this exact day group
          let updatedSegments = (weekObj[weekKey].segments || []).filter(
            (seg) =>
              !safeDays.some(
                (dayGroup) =>
                  seg.assigned_to === parent &&
                  Array.isArray(seg.selected_days) &&
                  seg.selected_days.join(" ") === dayGroup
              )
          );
          // Add new/updated segments
          safeDays.forEach((dayGroup) => {
            if (responsible && time) {
              updatedSegments.push({
                selected_days: dayGroup.split(" "),
                assigned_to: parent,
                responsible_for: responsible,
                ...(responsible === "pick_up"
                  ? { pickup_time: time === "Not setting a time" ? null : time }
                  : {
                      dropoff_time: time === "Not setting a time" ? null : time,
                    }),
              });
            }
          });
          return {
            ...weekObj,
            [weekKey]: {
              ...weekObj[weekKey],
              segments: updatedSegments,
            },
          };
        }
        return weekObj;
      });
      if (!found) {
        // Add new week object if not found
        return [
          ...prev,
          {
            [weekKey]: {
              week_number: selectedWeek,
              [`parent${selectedWeek}_id`]:
                selectedWeek === 1 ? parent1?.user_id : parent2?.user_id,
              segments: safeDays.map((dayGroup) => ({
                selected_days: dayGroup.split(" "),
                assigned_to: parent,
                responsible_for: responsible,
                ...(responsible === "pick_up"
                  ? { pickup_time: time }
                  : { dropoff_time: time }),
              })),
            },
          },
        ];
      }
      return updated;
    });
  };

  const handleParent1TabChange = (key, field, value) => {
    setParent1TabState((prev) => {
      const newState = {
        ...prev,
        [key]: { ...prev[key], [field]: value },
      };
      if (newState[key].responsible && newState[key].time) {
        saveSegments({
          parent: "parent1",
          days: [key],
          responsible: newState[key].responsible,
          time: newState[key].time,
        });
      }
      return newState;
    });
  };

  useEffect(() => {
    setSelectedTime(form.getFieldValue("time"));
  }, []);

  const renderTimeOptions = (selectedTime, onSelect) => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {timeOptions.map((option) => (
        <Tag.CheckableTag
          key={option}
          checked={selectedTime === option}
          onChange={() => onSelect(option)}
          style={{
            borderRadius: 8,
            padding: "4px 12px",
            backgroundColor: selectedTime === option ? "#f3e8ff" : "#f6f6f6",
            color: selectedTime === option ? "#9A4FE0" : "#000",
          }}
        >
          {option}
        </Tag.CheckableTag>
      ))}
      {customHour !== undefined && customMinute !== undefined && (
        <Tag.CheckableTag
          key="custom"
          checked={
            selectedTime ===
            `${String(customHour).padStart(2, "0")}:${String(
              customMinute
            ).padStart(2, "0")}`
          }
          onChange={() =>
            onSelect(
              `${String(customHour).padStart(2, "0")}:${String(
                customMinute
              ).padStart(2, "0")}`
            )
          }
          style={{
            borderRadius: 8,
            padding: "4px 12px",
            backgroundColor:
              selectedTime ===
              `${String(customHour).padStart(2, "0")}:${String(
                customMinute
              ).padStart(2, "0")}`
                ? "#f3e8ff"
                : "#f6f6f6",
            color:
              selectedTime ===
              `${String(customHour).padStart(2, "0")}:${String(
                customMinute
              ).padStart(2, "0")}`
                ? "#9A4FE0"
                : "#000",
          }}
        >
          {`${String(customHour).padStart(2, "0")}:${String(
            customMinute
          ).padStart(2, "0")}`}
        </Tag.CheckableTag>
      )}
      <Button
        type={showCustom ? "primary" : "dashed"}
        onClick={() => setShowCustom(!showCustom)}
      >
        Customize...
      </Button>
      <br />
      {showCustom && (
        <div
          style={{ marginTop: 16, display: "flex", gap: 8, alignItems: "left" }}
        >
          <Select
            placeholder="HH"
            value={customHour}
            onChange={setCustomHour}
            style={{ width: 80 }}
          >
            {Array.from({ length: 24 }, (_, i) => (
              <Select.Option key={i} value={i}>
                {String(i).padStart(2, "0")}
              </Select.Option>
            ))}
          </Select>
          <span>:</span>
          <Select
            placeholder="MM"
            value={customMinute}
            onChange={setCustomMinute}
            style={{ width: 80 }}
          >
            {[0, 15, 30, 45].map((i) => (
              <Select.Option key={i} value={i}>
                {String(i).padStart(2, "0")}
              </Select.Option>
            ))}
          </Select>
          <Button
            type="primary"
            disabled={customHour === undefined || customMinute === undefined}
            onClick={() => {
              const customTime = `${String(customHour).padStart(
                2,
                "0"
              )}:${String(customMinute).padStart(2, "0")}`;
              setSelectedTime(customTime);
              form.setFieldsValue({ time: customTime });
              setShowCustom(false);
              // Manually trigger onChange if needed
            }}
          >
            Save
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changed, all) => {
          if (changed.week) setSelectedWeek(changed.week);
          if (changed.responsibleFor)
            handleResponsibleForChange(changed.responsibleFor);
        }}
        onFinish={handleAddSegment}
      >
        <Form.Item required label="">
          <Tabs
            activeKey={parent1Days.length > 0 ? parent1Days[0] : undefined}
            onChange={(key) => {
              setParent1Days([key]);
              setParent1TabState((prev) => {
                if (prev[key]) return prev;
                const initial = getInitialTabValueFromV2(key, "parent1");
                return {
                  ...prev,
                  [key]: initial,
                };
              });
            }}
            type="card"
          >
            {weekDayGroups[selectedWeek].parent1.map((option) => (
              <TabPane tab={option.label} key={option.value}>
                <Form.Item label="Responsible For" required>
                  <Radio.Group
                    options={responsibleOptions}
                    value={parent1TabState[option.value]?.responsible}
                    onChange={(e) =>
                      handleParent1TabChange(
                        option.value,
                        "responsible",
                        e.target.value
                      )
                    }
                  />
                </Form.Item>
                {parent1TabState[option.value]?.responsible && (
                  <Form.Item
                    label={
                      parent1TabState[option.value]?.responsible === "pick_up"
                        ? `${parent1?.name || "Parent 1"} pick up time`
                        : `${parent2?.name || "Parent 2"} drop off time`
                    }
                    required
                  >
                    {renderTimeOptions(
                      parent1TabState[option.value]?.time,
                      (val) => handleParent1TabChange(option.value, "time", val)
                    )}
                  </Form.Item>
                )}
              </TabPane>
            ))}
          </Tabs>
        </Form.Item>
        <Form.Item
          required
          label={`${parent2?.name || "Parent 2"} Week ${selectedWeek} Days`}
        >
          <Tabs
            activeKey={parent2Days.length > 0 ? parent2Days[0] : undefined}
            onChange={(key) => {
              setParent2Days([key]);
              setParent2TabState((prev) => {
                if (prev[key]) return prev;
                const initial = getInitialTabValueFromV2(key, "parent2");
                return {
                  ...prev,
                  [key]: initial,
                };
              });
            }}
            type="card"
          >
            {weekDayGroups[selectedWeek].parent2.map((option) => (
              <TabPane tab={option.label} key={option.value}>
                <Form.Item label="Responsible For" required>
                  <Radio.Group
                    options={responsibleOptions}
                    value={parent2TabState[option.value]?.responsible}
                    onChange={(e) => {
                      setParent2TabState((prev) => {
                        const newState = {
                          ...prev,
                          [option.value]: {
                            ...prev[option.value],
                            responsible: e.target.value,
                          },
                        };
                        if (
                          newState[option.value].responsible &&
                          newState[option.value].time
                        ) {
                          saveSegments({
                            parent: "parent2",
                            days: [option.value],
                            responsible: newState[option.value].responsible,
                            time: newState[option.value].time,
                          });
                        }
                        return newState;
                      });
                    }}
                  />
                </Form.Item>
                {parent2TabState[option.value]?.responsible && (
                  <Form.Item
                    label={
                      parent2TabState[option.value]?.responsible === "pick_up"
                        ? `${parent2?.name || "Parent 2"} pick up time`
                        : `${parent1?.name || "Parent 1"} drop off time`
                    }
                    required
                  >
                    {renderTimeOptions(
                      parent2TabState[option.value]?.time,
                      (val) =>
                        setParent2TabState((prev) => {
                          const newState = {
                            ...prev,
                            [option.value]: {
                              ...prev[option.value],
                              time: val,
                            },
                          };
                          if (
                            newState[option.value].responsible &&
                            newState[option.value].time
                          ) {
                            saveSegments({
                              parent: "parent2",
                              days: [option.value],
                              responsible: newState[option.value].responsible,
                              time: val,
                            });
                          }
                          return newState;
                        })
                    )}
                  </Form.Item>
                )}
              </TabPane>
            ))}
          </Tabs>
        </Form.Item>
      </Form>
    </div>
  );
};

export default TwoTwoThreeCreate;
